import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '讯石数据-保障物联网安全'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software/Software'], resolve),
          meta: {
            title: '应用安全产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/tucp'
            },
            {
              path: '/software/tucp',
              name: 'software',
              component: resolve => require(['@/view/Software/Software_tucp'], resolve),
              meta: {
                title: '应用安全产品丨统一认证区块链平台'
              }
            },
            {
              path: '/software/system',
              name: 'software',
              component: resolve => require(['@/view/Software/Software_system'], resolve),
              meta: {
                title: '应用安全产品丨标识密钥管理系统'
              }
            },
            {
              path: '/software/terminal',
              name: 'software',
              component: resolve => require(['@/view/Software/Software_terminal'], resolve),
              meta: {
                title: '应用安全产品丨安全数传终端'
              }
            }
            ,
            {
              path: '/software/gateway',
              name: 'software',
              component: resolve => require(['@/view/Software/Software_gateway'], resolve),
              meta: {
                title: '应用安全产品丨边缘代理安全网关'
              }
            }
            ,
            {
              path: '/software/database',
              name: 'software',
              component: resolve => require(['@/view/Software/Software_database'], resolve),
              meta: {
                title: '应用安全产品丨数据库加密产品'
              }
            }
          ]
        },
        {
          path: '/basesoftware',
          name: 'basesoftware',
          component: resolve => require(['@/view/BaseSoftware/BaseSoftware'], resolve),
          meta: {
            title: '基础软件产品'
          },
          children: [
            {
              path: '/basesoftware',
              redirect: '/basesoftware/model'
            },
            {
              path: '/basesoftware/model',
              name: 'basesoftware',
              component: resolve => require(['@/view/BaseSoftware/BaseSoftware_model'], resolve),
              meta: {
                title: '基础软件产品丨芯片密码模块'
              }
            },
            {
              path: '/basesoftware/card',
              name: 'basesoftware',
              component: resolve => require(['@/view/BaseSoftware/BaseSoftware_card'], resolve),
              meta: {
                title: '基础软件产品丨PCIe 密码'
              }
            },
            {
              path: '/basesoftware/soft',
              name: 'basesoftware',
              component: resolve => require(['@/view/BaseSoftware/BaseSoftware_soft'], resolve),
              meta: {
                title: '基础软件产品丨讯石安全盾'
              }
            },
            {
              path: '/basesoftware/sdk',
              name: 'basesoftware',
              component: resolve => require(['@/view/BaseSoftware/BaseSoftware_sdk'], resolve),
              meta: {
                title: '基础软件产品丨SDK 开发工具'
              }
            }
          ]
        },{
          path: '/protocolSoftware',
          name: 'protocolSoftware',
          component: resolve => require(['@/view/ProtocolSoftware/ProtocolSoftware'], resolve),
          meta: {
            title: '协议层安全产品'
          },
          children: [
            {
              path: '/protocolSoftware',
              redirect: '/protocolSoftware/shield'
            },
            {
              path: '/protocolSoftware/shield',
              name: 'software',
              component: resolve => require(['@/view/ProtocolSoftware/ProtocolSoftware_shield'], resolve),
              meta: {
                title: '协议层安全产品丨M1000'
              }
            },
            {
              path: '/protocolSoftware/svpn',
              name: 'software',
              component: resolve => require(['@/view/ProtocolSoftware/ProtocolSoftware_svpn'], resolve),
              meta: {
                title: '协议层安全产品丨SVPN'
              }
            }
          ]
        },
        {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        },
        {
          path: '/technology',
          name: 'technology',
          component: resolve => require(['@/view/Technology'],resolve),
          meta: {
            title: '技术交流'
          },
          children: [
            {
              path: '/technology',
              redirect: '/technology/IPK1'
            },
            {
              path: '/technology/IPK1',
              name: 'technology',
              component: resolve => require(['@/view/Software/Software_IPK1'], resolve),
              meta: {
                title: 'IPK标识安全技术介绍'
              }
            },
            {
              path: '/technology/IPK2',
              name: 'technology',
              component: resolve => require(['@/view/Software/Software_IPK2'], resolve),
              meta: {
                title: '基于IPK技术的区块链安全实现'
              }
            }
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js